export const environment = {
  production: false,
  apiUrl: 'https://api.test.appointment.bot',
  version: '0.1.0',
  name: 'feature',
  buildDate: new Date().toISOString(),
  featureTesting: true,
  debugMode: true
};